import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  // PORTAL AMPLUS
  {
    title: 'Tela Inicial',
    icon: 'home-outline',
    link: '/pages/iot-dashboard',
    data: { roles: ['DASHBOARD'] },
    hidden: true,
  },
  {
    title: 'Backoffice',
    icon: 'monitor-outline',
    link: '/pages/backoffice',
    data: { roles: ['BACKOFFIC'] },
    hidden: true,
    children: [
      {
        title: 'Atualização Cadastral',
        link: '/pages/backoffice/alteracao-cadastral-cliente',
        data: { roles: ['ATUALIZACAO_CADASTRAL'] },
        hidden: true,
      },
      {
        title: 'Autorizar Novo Dispositivo',
        link: '/pages/backoffice/autorizar-novo-dispositivo',
        data: { roles: ['AUTORIZAR_NOVO_DISPOSITIVO'] },
        hidden: true,
      },
      {
        title: 'Gestão Usuário Backoffice',
        link: '/pages/backoffice/gestao-usuario-backoffice',
        data: { roles: ['GESTAO_USUARIO_BACKOFFICE'] },
        hidden: true,
      },
      {
        title: 'Criar Senha Temporária',
        link: '/pages/backoffice/criar-senha-temporaria',
        data: { roles: ['CRIAR_SENHA_TEMPORARIA'] },
        hidden: true,
      },
      {
        title: 'Extrato Conta Orbital',
        link: '/pages/backoffice/extrato-conta-orbital',
        data: {roles: ['EXTRATO_CONTA_ORBITAL']},
        hidden: true,
      },
      {
        title: 'Extrato Conta Usuário',
        link: '/pages/backoffice/extrato-conta-usuario',
        data: {roles: ['EXTRATO_CONTA_ORBITAL']},
        hidden: true,
      },
      {
        title: 'Extrato Conta BMP',
        link: '/pages/backoffice/extrato-conta-bmp',
        data: {roles: ['EXTRATO_CONTA_BMP']},
        hidden: true,
      },
      {
        title: 'Monitoramento',
        data: { roles: ['GESTAO_ONBOARDING', 'JOB_SCHEDULER', 'AGENDA_FINANCEIRA'] },
        hidden: true,
        children: [
          {
            title: 'Gestão Onboarding',
            link: '/pages/backoffice/gestao-onboarding',
            data: {roles: ['GESTAO_ONBOARDING']},
            hidden: true,
          },
          {
            title: 'Gestão Requisitar Cartões',
            link: '/pages/backoffice/gestao-requisitar-cartoes',
            data: {roles: ['GESTAO_REQUISITAR_CARTOES']},
            hidden: true,
          },
          {
            title: 'Job Scheduler',
            link: '/pages/backoffice/job-scheculer',
            data: {roles: ['JOB_SCHEDULER']},
            hidden: true,
          },
          {
            title: 'Agenda Financeira',
            link: '/pages/monitoramento/agenda-financeira',
            data: {roles: ['AGENDA_FINANCEIRA']},
            hidden: true,
          },
          {
            title: 'Movimentações Pix',
            link: '/pages/backoffice/consulta-movimentacoes-pix',
            data: {roles: ['MOVIMENTACOES_PIX']},
            hidden: true,
          }
        ]
      },
      {
        title: 'Vale Estar Bem',
        data: { roles: ['BACKOFFIC'] },
        hidden: true,
        children: [
          {
            title: 'Gestão Beneficiário',
            link: '/pages/backoffice/vale-estar-bem/gestao-beneficiario',
            data: {roles: ['BACKOFFIC']},
            hidden: true,
          },

        ]
      },
      {
          title: 'Trava MCC',
          icon: 'credit-card-outline',
          data: {roles: ['RESTRICAO_MCC']},
          hidden: true,
          children: [
          {
            title: 'Restringir MCC\'s Produto',
            link: '/pages/backoffice/restringir-mcc-produto',
            data: { roles: ['RESTRICAO_MCC'] },
            hidden: true,
          },
          {
            title: 'Restringir MCC\'s Cliente',
            link: '/pages/backoffice/restringir-mcc-cliente',
            data: { roles: ['RESTRICAO_MCC'] },
            hidden: true,
          },
          {
            title: 'Restringir MCC\'s Cartão',
            link: '/pages/backoffice/restringir-mcc-produto-cliente-cartao',
            data: { roles: ['RESTRICAO_MCC'] },
            hidden: true,
          }
        ]
        },
      {
        title: 'Limites PIX',
        link: '/pages/backoffice/aprovacao-pix',
        data: {roles: ['LIMITES_PIX']},
        hidden: true,
      },
      {
        title: 'Embossing',
        data: { roles: ['GESTAO_ONBOARDING', 'JOB_SCHEDULER', 'AGENDA_FINANCEIRA'] },
        hidden: true,
        children: [
          {
            title: 'Importar Cartão',
            link: '/pages/backoffice/importar-cartao',
            data: {roles: ['GESTAO_ONBOARDING']},
            hidden: true,
          },
          {
                title: 'Vincular cartões',
                link: '/pages/gestao-cartoes/vinculo-cartoes-noname',
                data: {roles: ['ASSOCIA_CARTAO_EMPRESA']},
                hidden: true,
           }
        ]
      },
    ]
  },
  {
    title: 'Gestão de Usuário Terceiro',
    icon: 'people-outline',
    data: { roles: ['GESTAO_DE_USUARIO'] },
    hidden: true,
    children: [
      {
        title: 'Gestão de Usuário Terceiro',
        link: '/pages/gestao-user-terceiro/lista-user-terceiro',
        data: { roles: ['CADASTRO_DE_USUARIO_TERCEIRO'] },
        hidden: true,
      },
      {
        title: 'Administração Grupo',
        link: '/pages/gestao-user-terceiro/lista-admin-grupo',
        data: { roles: ['ADMINISTRACAO_GRUPO'] },
        hidden: true,
      },
      {
        title: 'Associar Usuário Terceiro Grupo',
        link: '/pages/gestao-user-terceiro/lista-associar-user-terceiro-grupo',
        data: { roles: ['ASSOCIAR_USUARIO_TERCEIRO_GRUPO'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Gestão de Funcionários',
    icon: 'people-outline',
    data: { roles: ['GESTAO_FUNCIONARIO'] },
    hidden: true,
    children: [
      {
        title: 'Cadastro individual',
        link: '/pages/gestao-funcionarios/lista-funcionario',
        data: { roles: ['CADASTRAR_FUNCIONARIO'] },
        hidden: true,
      },
      {
        title: 'Consultar Funcionários',
        link: '/pages/gestao-funcionarios/consultar-funcionario',
        data: { roles: ['CONSULTAR_FUNCIONARIOS'] },
        hidden: true,
      },
      {
        title: 'Rollout de Funcionários',
        data: { roles: ['ROLLOUT_FUNCIONARIOS'], checkProductRolloutMigrated: true },
        hidden: true,
        children: [
          {
            title: 'Migrar Funcionários',
            link: '/pages/gestao-funcionarios/migrar-funcionarios',
            data: { roles: ['MIGRAR_FUNCIONARIOS'] },
            hidden: true,
          },
          {
            title: 'Acompanhar Migrações',
            link: '/pages/gestao-funcionarios/acompanhar-migracoes',
            data: { roles: ['ACOMPANHAR_MIGRACOES'] },
            hidden: true,
          },
        ],
      },
      {
        title: 'Solicitar 1ª via',
        link: '/pages/gestao-funcionarios/listar-vinculo-produto',
        data: { roles: ['SOLICITAR_1_VIA'] },
        hidden: true,
      },
      {
        title: 'Alterar status do funcionário',
        link: '/pages/gestao-funcionarios/lista-alteracao-status',
        data: { roles: ['ALTERAR_STATUS_FUNCIONARIO'] },
        hidden: true,
      },
      {
        title: 'Demitir funcionário',
        link: '/pages/gestao-funcionarios/demissao-funcionarios',
        data: { roles: ['DEMITIR_FUNCIONARIO'] },
        hidden: true,
      },
      {
        title: 'Cadastro por planilha',
        link: '/pages/gestao-funcionarios/importacao-lote',
        data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] },
        hidden: true,
      },
      {
        title: 'Cadastro e 1ª via em lote',
        data: { roles: ['CADASTRO_E_1_VIA_EM_LOTE'] },
        hidden: true,
        children: [
          {
            title: 'Importar arquivo',
            link: '/pages/gestao-funcionarios/importacao-funcionarios',
            data: { roles: ['IMPORTAR_ARQUIVO_LOTE'] },
            hidden: true,
          },
          {
            title: 'Acompanhar importação',
            link: '/pages/gestao-funcionarios/consulta-arquivos-importacao-funcionarios',
            data: { roles: ['ACOMPANHAR_IMPORTACAO_LOTE'] },
            hidden: true,
          },
          {
            title: 'Importar arquivo',
            link: '/pages/gestao-funcionarios/importar-arquivo-funcionario',
            data: { roles: ['CADASTRO_FUNCIONARIO_1VIA'] },
            hidden: true,
          },
          {
            title: 'Histórico de Importação',
            link: '/pages/gestao-saldo/historico-importacao',
            data: { roles: ['HISTORICO_IMPORTACAO_FUNCIONARIO'] },
            hidden: true,
          },
        ],
      },
      {
        title: 'Alteração de Limite',
        data: { roles: ['ALTERACAO_DE_LIMITE'] },
        hidden: true,
        children: [
          {
            title: 'Solicitar Alteração',
            link: '/pages/gestao-funcionarios/lista-alteracao-limite',
            data: { roles: ['ALTERAR_STATUS_FUNCIONARIO'] },
            hidden: true,
          },
        ],
      },
      {
        title: 'Consulta de Saldos',
        link: '/pages/gestao-funcionarios',
        data: { roles: ['CONSULTA_DE_SALDOS'] },
        hidden: true,
      },

    ],
  },

  {
    title: 'Gestão de Saldo',
    icon: 'flip-2-outline',
    data: { roles: ['GESTAO_DE_SALDO'] },
    hidden: true,
    children: [
      {
        title: 'Carga Individual',
        link: '/pages/gestao-saldo/realizar-carga',
        data: { roles: ['REALIZAR_CARGA'] },
        hidden: true,
      },
      {
        title: 'Carga por Planilha',
        link: '/pages/gestao-saldo/importacao-carga-lote',
        data: { roles: ['CARGA_EM_LOTE'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Gestão de Limite',
    icon: 'flip-2-outline',
    data: { roles: ['ALTERACAO_DE_LIMITE'] },
    hidden: true,
    children: [
      {
        title: 'Alteração em Lote',
        data: { roles: ['ALTERACAO_DE_LIMITE'] },
        hidden: true,
        children: [
          {
            title: 'Importar arquivo',
            link: '/pages/gestao-saldo/importacao-carga-salario',
            data: { roles: ['ALTERACAO_DE_LIMITE'] },
            hidden: true,
          },
          {
            title: 'Acompanhar importação',
            link: '/pages/gestao-saldo/consulta-arquivos-importacao-carga-salario',
            data: { roles: ['ALTERACAO_DE_LIMITE'] },
            hidden: true,
          },
        ],
      },
    ],
  },
  {
    title: 'Adiantamento Salarial',
    icon: 'layout-outline',
    data: { roles: ['ADIANTAMENTO_SALARIAL'] },
    hidden: true,
    children: [
      {
        title: 'Solicitações Abertas',
        link: '/pages/gestao-funcionarios',
        data: { roles: ['SOLICITACOES_ABERTAS'] },
        hidden: true,
      },
      {
        title: 'Histórico de Solicitações',
        link: '/pages/gestao-funcionarios',
        data: { roles: ['HISTORICO_DE_SOLICITACOES'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Cartão No Name',
    icon: 'credit-card-outline',
    data: { roles: ['CARTAO_NO_NAME'] },
    hidden: true,
    children: [
      {
        title: 'Vincular',
        link: '/pages/card-no-name/vincular-card',
        data: { roles: ['VINCULAR'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Financeiro',
    icon: 'layout-outline',
    data: { roles: ['FINANCEIRO'] },
    hidden: true,
    children: [
      {
        title: 'Gestão Financeira',
        link: '/pages/financeiro/gestao-financeira',
        data: { roles: ['GESTAO_FINANCEIRA'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Relatório',
    icon: 'file-text-outline',
    data: { roles: ['RELATORIO', 'ROLE_MOVIMENTACAO_GERAL'] },
    hidden: true,
    children: [
      {
        title: 'Demonstrativo Consumo',
        link: '/pages/relatorio/demonstrativo-consumo',
        data: { roles: ['DEMONSTRATIVO_CONSUMO'] },
        hidden: true,
      },
      {
        title: 'Demonstrativo Consumo PJ',
        link: '/pages/relatorio/demonstrativo-consumo-pj',
        data: { roles: ['DEMONSTRATIVO_CONSUMO_PJ'] },
        hidden: true,
      },
      {
        title: 'Relatório AGL',
        link: '/pages/relatorio/relatorio-agl',
        data: { roles: ['RELATORIO_AGL'] },
        hidden: true,
      },
      {
        title: 'Extrato por cartão',
        link: '/pages/relatorio/extrato-cartao',
        data: { roles: ['EXTRATO_POR_CARTAO'] },
        hidden: true,
      },
      {
        title: 'Extrato Geral',
        link: '/pages/relatorio/extrato-geral',
        data: { roles: ['EXTRATO_GERAL'] },
        hidden: true,
      },
      {
        title: 'Movimentação Geral',
        link: '/pages/relatorio/movimentacao-geral',
        data: { roles: ['ROLE_MOVIMENTACAO_GERAL'] },
        hidden: true,
      },
      {
        title: 'Extrato de Planos',
        link: '/pages/relatorio/extrato-plano',
        data: { roles: ['EXTRATO_GERAL'] },
        hidden: true,
      },
      {
        title: 'Histórico de Alterações de Limite',
        link: '/pages/relatorio/historico-alteracao-limite',
        data: { roles: ['HISTORICO_DE_ALTERACOES_DE_LIMITE'] },
        hidden: true,
      },
      {
        title: 'Relatório de Cargas',
        link: '/pages/relatorio/relatorio-carga',
        data: { roles: ['RELATORIO_CARGAS'] },
        hidden: true,
      },
      {
        title: 'Relação de Funcionários',
        link: '/pages/relatorio/relacao-funcionarios',
        data: { roles: ['RELACAO_DE_FUNCIONARIOS'] },
        hidden: true,
      },
      {
        title: 'Extrato de Cartões Despesas',
        link: '/pages/relatorio/extrato-cartoes-viagem',
        data: { roles: ['EXTRATO_CARTOES_VIAGEM'] },
        hidden: true,
      },
      {
        title: 'Relatório de Plano Despesas',
        link: '/pages/relatorio/relatorio-plano-viagem',
        data: { roles: ['RELATORIO_PLANO_VIAGEM'] },
        hidden: true,
      },
      {
        title: 'Relação de Cartões',
        link: '/pages/relatorio/relatorio-relacao-cartoes',
        data: { roles: ['RELATORIO_RELACAO_CARTOES'] },
        hidden: true,
      },
      {
        title: 'Cartões por funcionário',
        link: '/pages/relatorio/cartoes-por-funcionario',
        data: { roles: ['RELATORIO_CARTOES_FUNCIONARIO'] },
        hidden: true,
      },
      {
        title: 'Transações Recusadas',
        link: '/pages/relatorio/relatorio-transacoes-recusadas',
        data: { roles: ['RESTRICAO_MCC'] },
        hidden: true,
      },
      {
        title: 'MCC por Grupo',
        link: '/pages/relatorio/relatorio-grupo-mcc',
        data: { roles: ['RESTRICAO_MCC'] },
        hidden: true,
      },
      {
        title: 'Trava Mcc Produto',
        link: '/pages/relatorio/relatorio-trava-mcc-produto',
        data: { roles: ['RESTRICAO_MCC'] },
        hidden: true,
      },
      {
        title: 'Trava Mcc Cliente',
        link: '/pages/relatorio/relatorio-trava-mcc-cliente',
        data: { roles: ['RESTRICAO_MCC'] },
        hidden: true,
      },
      {
        title: 'Trava Mcc Cartão',
        link: '/pages/relatorio/relatorio-trava-mcc-produto-cliente-cartao',
        data: { roles: ['RESTRICAO_MCC'] },
        hidden: true,
      },
      {
        title: 'Extrato de Movimentações',
        link: '/pages/relatorio/extrato-movimentacoes',
        data: { roles: ['EXTRATO_MOVIMENTACOES_VIAGEM'] },
        hidden: true,
      },
      {
        title: 'Relatório por Tipo de Cargas',
        link: '/pages/relatorio/relatorio-tipo-carga',
        data: { roles: ['RELATORIO_POR_TIPO'] },
        hidden: true,
      },
      {
        title: 'Extrato de Cargas',
        link: '/pages/relatorio/extrato-carga',
        data: { roles: ['EXTRATO_DE_CARGAS'] },
        hidden: true,
      },
      {
        title: 'Cashin VEB',
        link: '/pages/relatorio/consultar-cashins',
        data: { roles: ['CONSULTA_CASHIN'] },
        hidden: true,
      },
      {
        title: 'Cashouts Boletos Recusados',
        link: '/pages/relatorio/consultar-cashouts',
        data: { roles: ['CONSULTA_CASHOUT'] },
        hidden: true,
      },
      {
        title: 'Movimentação de Saldo',
        link: '/pages/relatorio/relatorio-movimentacao-saldo',
        data: { roles: ['RELATORIO_MOVIMENTACAO_SALDO'] },
        hidden: true,
      },
      {
        title: 'Cartão Internacional',
        link: '/pages/relatorio/relatorio-cartao-internacional',
        data: { roles: ['RELATORIO_CARTAO_INTERNACIONAL'] },
        hidden: true,
      },
      {
        title: 'Gastos por Centro de Custo',
        link: '/pages/relatorio/relatorio-gastos-centro-custo',
        data: { roles: ['RELATORIO_GASTOS_CENTRO_CUSTO'] },
        hidden: true,
      },
      {
        title: 'Despesas por Colaborador',
        link: '/pages/relatorio/relatorio-despesa-colaborador',
        data: { roles: ['RELATORIO_DESPESA_COLABORADOR'] },
        hidden: true,
      },
      {
        title: 'Despesas por centro de custo',
        link: '/pages/relatorio/relatorio-despesa-centro-custo-detalhado',
        data: { roles: ['RELATORIO_DESPESA_CENTRO_CUSTO'] },
      },
      {
        title: 'Relatório de Segmentos',
        link: '/pages/relatorio/relatorio-grupo-segmento',
        data: { roles: ['RELATORIO_SEGMENTO'] },
        hidden: true,
      },
    ],
  },
  {
    title: 'Parcelamento Inteligente',
    icon: 'file-text-outline',
    data: { roles: ['PARCELAMENTO_INTELIGENTE'] },
    hidden: true,
    children: [
      {
        title: 'Simulação',
        link: '/pages/pagamento-inteligente/simulacao-venda',
        data: { roles: ['SIMULACAO_DE_VENDA'] },
        hidden: true,
      },
      {
        title: 'Simulação WebTef',
        link: '/pages/pagamento-inteligente/simulacao-venda-webtef',
        data: { roles: ['SIMULACAO_DE_VENDA_WEBTEF'] },
        hidden: true,
      },
      {
        title: 'Lista Simulaçao',
        link: '/pages/pagamento-inteligente/lista-simulacao',
        data: { roles: ['LISTA_SIMULACAO'] },
        hidden: true,
      },
      {
        title: 'Historico Venda',
        link: '/pages/pagamento-inteligente/historico-venda',
        data: { roles: ['HISTORICO_VENDA'] },
        hidden: true,
      },

    ],

  },
  {
    title: 'Gestão de Vendas',
    icon: 'bar-chart-2-outline',
    data: { roles: ['GESTAO_VENDAS'] },
    hidden: true,
    children: [
      {
        title: 'Buscar Vendas',
        link: '/pages/gestao-vendas/busca-venda-realizada-pinpad',
        data: { roles: ['BUSCAR_VENDAS_REALIZADA'] },
        hidden: true,
      },
      {
        title: 'Estornar Venda',
        link: '/pages/gestao-vendas/estorno-venda-realizada-pinpad',
        data: { roles: ['ESTORNAR_VENDA_REALIZADA'] },
        hidden: true,
      },
      {
        title: 'Buscar Vendas WebTef',
        link: '/pages/gestao-vendas/busca-venda-realizada-pinpad-webtef',
        data: { roles: ['BUSCAR_VENDAS_REALIZADA_WEBTEF'] },
        hidden: true,
      },
      {
        title: 'Estornar Venda WebTef',
        link: '/pages/gestao-vendas/estorno-venda-realizada-pinpad-webtef',
        data: { roles: ['ESTORNAR_VENDA_REALIZADA_WEBTEF'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Agiliza Fornecedor',
    icon: 'shopping-cart-outline',
    data: { roles: ['COMPRA_ONLINE'] },
    hidden: true,
    children: [
      {
        title: 'Gerar Pedido De Venda',
        link: '/pages/compra-online/gerar-pedido',
        data: { roles: ['GERAR_PEDIDO_DE_VENDA'] },
        hidden: true,
      },
      {
        title: 'Consultar Pedidos Recebidos',
        link: '/pages/compra-online/consulta-pedido-recebido',
        data: { roles: ['CONSULTAR_PEDIDOS_RECEBIDOS'] },
        hidden: true,
      },
      {
        title: 'Consultar Pedidos Solicitados',
        link: '/pages/compra-online/consulta-pedido-aprovado',
        data: { roles: ['CONSULTAR_PEDIDOS_APROVADOS'] },
        hidden: true,
      },
      {
        title: 'Relação de Indústria',
        link: '/pages/compra-online/relacao-industria',
        data: { roles: ['RELACAO_INDUSTRIA'] },
        hidden: true,
      },
      {
         title: 'Plataforma de Pagamento',
        link: '/pages/compra-online/plataforma-pagamento',
        data: {roles: ['PLATAFORMA_DE_PAGAMENTO']},
        hidden: true,
      },
    ]

  },
  {
    title: 'Reuso Automático',
    icon: 'shopping-cart-outline',
    data: { roles: ['REUSO_AUTOMATICO'] },
    hidden: true,
    children: [
      {
        title: 'Cadastrar Vendas',
        link: '/pages/reuso-automatico/lista-vendas',
        data: { roles: ['CADASTRAR_VENDAS'] },
        hidden: true,
      },
      {
        title: 'Listar Reusos Cadastrados',
        link: '/pages/reuso-automatico/listar-reuso-cadastrado',
        data: { roles: ['LISTAR_REUSOS_CADASTRADOS'] },
        hidden: true,
      },
      {
        title: 'Listar Reusos Vinculados',
        link: '/pages/reuso-automatico/listar-reuso-vinculado',
        data: { roles: ['LISTAR_REUSOS_VINCULADOS'] },
        hidden: true,
      },
      {
        title: 'Extrato Reuso Automático',
        link: '/pages/reuso-automatico/extrato-reuso-automatico',
        data: { roles: ['EXTRATO_REUSO_AUTOMATICO'] },
        hidden: true,
      },

    ],

  },
  {
    title: 'Gestão de Cartões',
    icon: 'credit-card-outline',
    data: { roles: ['GESTAO_CARTOES'] },
    hidden: true,
    children: [
      {
        title: 'Gerar Senha',
        link: '/pages/gestao-cartoes/gerar-senha',
        data: { roles: ['GERAR_SENHA'] },
        hidden: true,
      },
      {
        title: 'Solicitação Cartão Despesa',
        link: '/pages/gestao-cartoes/solicitacao-cartao',
        data: { roles: ['SOLICITACAO_CARTAO'] },
        hidden: true,
      },
      {
        title: 'Solicitação cartão em lote',
        link: '/pages/gestao-cartoes/solicitacao-cartao-lote',
        data: { roles: ['SOLICITACAO_DE_CARTAO_EM_LOTE'] },
        hidden: true,
        children: [
          {
            title: 'Importar arquivo',
            link: '/pages/gestao-cartoes/importar-arquivo',
            data: { roles: ['IMPORTAR_ARQUIVO'] },
            hidden: true,
          },
        ],
      },
      {
        title: 'Acompanhar Solicitação Cartões',
        link: '/pages/gestao-cartoes/acompanhar-solicitacao-cartao',
        data: { roles: ['ACOMPANHAR_SOLICITACAO_CARTOES'] },
        hidden: true,
      },
      // {
      //   title: 'Ativação/Desbloqueio Cartão',
      //   link: '/pages/gestao-cartoes/ativacao-cartao',
      //   data: { roles: ['ATIVACAO_CARTAO'] },
      //   hidden: true,
      // },
      {
        title: 'Ativação cartão em lote',
        link: '/pages/gestao-cartoes/ativacao-cartao-lote',
        data: { roles: ['ATIVACAO_CARTAO'] },
        hidden: true,
      },
      {
        title: 'Consulta Saldo Cartão',
        link: '/pages/gestao-cartoes/consulta-saldo-cartao',
        data: { roles: ['CONSULTA_SALDO_CARTAO'] },
        hidden: true,
      },
      {
        title: 'Consulta Senha Cartão',
        link: '/pages/gestao-cartoes/consulta-senha-cartao',
        data: { roles: ['CONSULTA_SENHA_CARTAO'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Gestão de Plano de Despesas',
    icon: 'layout-outline',
    data: { roles: ['GESTAO_PLANO_VIAGEM'] },
    hidden: true,
    children: [
      {
        title: 'Plano de Despesas',
        link: '/pages/gestao-plano-viagem/plano-viagens',
        data: { roles: ['PLANO_DE_VIAGENS'] },
        hidden: true,
      },
      {
        title: 'Gestão de Justificativas',
        link: '/pages/gestao-plano-viagem/gestao-justificativas',
        data: { roles: ['GESTAO_JUSTIFICATIVA'] },
        hidden: true,
      },
      {
        title: 'Plano de Despesas em lote',
        data: { roles: ['PLANO_VIAGEM_EM_LOTE'] },
        hidden: true,
        children: [
          {
            title: 'Importar arquivo',
            link: '/pages/gestao-plano-viagem/importacao-plano-viagem',
            data: { roles: ['IMPORTAR_ARQUIVO_PLANO_VIAGEM_LOTE'] },
            hidden: true,
          },
          {
            title: 'Acompanhar importação',
            link: '/pages/gestao-plano-viagem/consulta-arquivos-importacao-plano-viagem',
            data: { roles: ['ACOMPANHAR_IMPORTACAO_PLANO_VIAGEM_LOTE'] },
            hidden: true,
          },
        ],
      },
      {
        title: 'Habilita Extrato',
        link: '/pages/gestao-plano-viagem/permissao-extrato-plano-viagem',
        data: { roles: ['PLANO_DE_VIAGENS'] },
        hidden: true,
      },

    ],

  },
  {
    title: 'Gestão de Centros de Custos',
    icon: 'layout-outline',
    data: { roles: ['GESTAO_CENTRO_CUSTO'] },
    hidden: true,
    children: [
      {
        title: 'Centro de custo',
        link: '/pages/gestao-plano-viagem/centro-custo',
        data: { roles: ['CENTRO_CUSTO'] },
        hidden: true,
      }
    ]
  },
  {
    title: 'Onboarding',
    icon: 'layout-outline',
    data: { roles: ['ONBOARDING'] },
    hidden: true,
    children: [
      {
        title: 'Onboarding Empresa',
        link: '/pages/onboarding/onboarding-empresa',
        data: { roles: ['ONBOARDING_EMPRESA'] },
        hidden: true,
      },
      {
        title: 'Onboarding Funcionário',
        link: '/pages/onboarding/onboarding-funcionario',
        data: { roles: ['ONBOARDING_FUNCIONARIO'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Conciliador Contas',
    icon: 'edit-outline',
    data: { roles: ['CONCILIADOR_CONTAS'] },
    hidden: true,
    children: [
      {
        title: 'Conciliador TopBank x Topaz',
        link: '/pages/conciliador-contas/conciliador-contas-topBank-topaz',
        data: { roles: ['CONCILIADOR_CONTAS_TOPAZ'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Notificação',
    icon: 'browser-outline',
    data: { roles: ['NOTIFICACAO'] },
    hidden: true,
    children: [
      {
        title: 'Notificação Manual',
        link: '/pages/notificacao/notificacao-manual',
        data: { roles: ['NOTIFICACAO_MANUAL'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Split de Vendas',
    icon: 'browser-outline',
    data: { roles: ['SPLIT_DE_VENDAS'] },
    hidden: true,
    children: [
      {
        title: 'Associações',
        link: '/pages/split-vendas/associacoes',
        data: { roles: ['ASSOCIACOES'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Pré-Pago',
    icon: 'flip-outline',
    data: { roles: ['PRE_PAGO'] },
    hidden: true,
    children: [
      {
        title: 'Gestão de Pedido',
        link: '/pages/boleto-pre-pago/solicite-pedido-pre-pago',
        data: { roles: ['SOLICITE_SEU_PEDIDO'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Plataforma de Cotação',
    icon: 'layout-outline',
    data: { roles: ['PLATAFORMA_DE_COTACAO'] },
    hidden: true,
    children: [
      {
        title: 'Consultar Cotações',
        link: '/pages/plataforma-cotacao/consultar-cotacao',
        data: { roles: ['CONSULTAR_COTACAO'] },
        hidden: true,
      },
      {
        title: 'Configure Seu Estabelecimento',
        link: '/pages/plataforma-cotacao/configuracao-estabelecimento',
        data: { roles: ['CONFIGURE_SEU_ESTABELECIMENTO'] },
        hidden: true,
      },
      {
        title: 'Pedidos Aprovados',
        link: '/pages/plataforma-cotacao/pedidos-aprovados',
        data: { roles: ['PEDIDOS_APROVADOS'] },
        hidden: true,
      },
    ],

  },
  {
    title: 'Gestão Bancaria',
    icon: 'people-outline',
    data: { roles: ['GESTAO_BANCARIA'] },
    hidden: true,
    children: [
      {
        title: 'Extrato da Conta',
        link: '/pages/gestao-bancaria/extrato-conta',
        data: { roles: ['EXTRATO_DA_CONTA'] },
        hidden: true,
      },
      {
        title: 'Realizar Transferencia Individual',
        link: '/pages/gestao-bancaria/transferencia-individual',
        data: { roles: ['REALIZAR_TRANSF_INDIVIDUAL'] },
        hidden: true,
      },
      {
        title: 'Importar Transferencia em lote',
        link: '/pages/gestao-bancaria/importacao-transferencia',
        data: { roles: ['REALIZAR_TRANSF_LOTE'] },
        hidden: true,
      },
      {
        title: 'Consultar Transferencia em lote',
        link: '/pages/gestao-bancaria/consulta-arquivo-importacao-transferencia',
        data: { roles: ['ACOMPANHAR_TRANSF_LOTE'] },
        hidden: true,
      },
    ],
  },
{
    title: 'Gestão de Cartões No Name',
    icon: 'credit-card-outline',
    data: {roles: ['GESTAO_DE_CARTOES']},
    hidden: true,
    children: [
      {
        title: 'Solicitar Cartões',
        link: '/pages/gestao-lote-cartao/gerar-lote-cartao',
        data: {roles: ['GERAR_LOTE_CARTAO']},
        hidden: true,
      },
      {
        title: 'Cadastrar funcionários',
        link: '/pages/gestao-lote-cartao/cadastrar-funcionario-no-name',
        data: {roles: ['CADASTRO_FUNCIONARIO_NONAME']},
        hidden: true,
      },
      {
        title: 'Cadastro por planilha',
        link: '/pages/gestao-lote-cartao/importacao-lote',
        data: {roles: ['IMPORTAR_LOTE_FUNCIONARIO_NO_NAME']},
        hidden: true,
      },
      {
        title: 'Associar Funcionários',
        link: '/pages/gestao-lote-cartao/associar-manualmente',
        data: {roles: ['REGISTRAR_CARTAO']},
        hidden: true,
      },
    ]
  },
];

export const MENU_ITEMS_IGNORED: NbMenuItem[] = [
  {
    title: 'Extrato de Planos',
    link: '/pages/relatorio/extrato-plano',
    data: { roles: ['EXTRATO_GERAL'] },
    hidden: true,
  },
];
